import { useCallback, useRef } from 'react'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

export function useSyncTotalItems() {
  const { totalItems, setTotalItems } = usePrivateIntegrationsSyncContext()
  const lastTotal = useRef<number | undefined>(totalItems)

  const trackTotal = useCallback(
    (total: number) => {
      if (lastTotal.current !== total) {
        lastTotal.current = total
        setTotalItems(total)
      }
    },
    [setTotalItems]
  )

  return { totalItems, setTotalItems: trackTotal }
}
